import UserLayout from "../components/UserLayout";
import MemberDetails from "../components/user/MemberDetails";

const MembersDetailsPage = () => {
    return (
        <UserLayout>
            <MemberDetails />
        </UserLayout>
    );
}

export default MembersDetailsPage;